import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import {
    fetchActivePlan,
    selectActivePlan,
} from '../features/nutrition/nutrition-plan/nutrition-plan.slice';

const useActiveNutritionPlan = (memberId?: number) => {
    const dispatch = useAppDispatch();
    const nutritionPlan = useAppSelector(selectActivePlan);

    useEffect(() => {
        if (!memberId || memberId <= 0) return;

        const fetchPlan = async () => {
            await dispatch(fetchActivePlan(memberId));
        };

        fetchPlan();
    }, [memberId, dispatch]);

    return nutritionPlan;
};

export default useActiveNutritionPlan;
